import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Select,
  Icon,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Spinner,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCheck,
  FaExclamation,
  FaEye,
  FaFileExport,
  FaLink,
  FaPlay,
  FaPlus,
  FaTimes,
} from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState, useRecoilState } from "recoil";
import moment from "moment";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import {
  dateForAPI,
  dateForList,
  dateForListWithHours,
} from "../../../constants/dataFormat";
import PaymentApi from "../../../services/paymentApi";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import { goToAddPayment } from "../../../routes/coordinator";
import { HamburgerIcon } from "@chakra-ui/icons";
import ModalDeleteConfirmation from "./components/modalDeleteConfirmation";
import ModalPaymentDetail from "./components/modalPaymentDetail";
import Pagination from "../../../defaultComponents/pagination";
import { JWTToken } from "../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { CNPJFormater, CPFFormater } from "../../../defaultFunctions/formaters";
import { baseURL } from "../../../services/api";
import md5 from "md5";
import ValueDropdown from "../listaDeVendas/defaultComponent/valueDropdown";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import ModalDetails from "./components/modalDetails";
import { permissions } from "../../../atoms/permissions";
import { customColors } from "../../../atoms/customColors";
import { goToAddPaymentNew } from "../../../routes/coordinator";
interface PaymentList {
  atualizadoEm: string;
  codigoBarras: string;
  cliente: {
    ativo: boolean;
    cnpj: string;
    email: string;
    id: number;
    idPlano: number;
    idPromocao: number;
    isCnpj: boolean;
    nome: string;
    nomeFantasia: string;
    razaoSocial: string;
    sobrenome: string;
  };
  pagamentosHistorico: [paymentHistorico];
  criadoEm: string;
  dataPagamento: string;
  descontos: number;
  id: number;
  idCliente: number;
  idStatus: number;
  juros: number;
  observacao: string;
  status: {
    id: number;
    status: string;
  };
  urlArquivo: string;
  urlRecibo: string;
  valorNominal: number;
  valorPagamento: number;
  vencimento: string;
}

export interface paymentHistorico {
  atualizadoEm: string;
  criadoEm: string;
  data: string;
  hora: string;
  id: number;
  idPagamento: number;
  idStatus: number;
  observacao: string;
}

export default function PaymentSolicitation() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<PaymentList>);
  const [isOpen, setIsOpen] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(Array<paymentHistorico>);
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const [openDelete, setOpenDelete] = useState(false);

  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: moment().startOf("day").format(dateForAPI),
    finalDateFilter: moment().endOf("day").format(dateForAPI),
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [idBoleto, setIdBoleto] = useState(0);
  const [details, setDetails] = useState({});
  const colors = useRecoilState(customColors)[0];

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const id = Number(jwtToken.idCliente);
  const idTipoUsuario = jwtToken.idTipoUsuario;
  const perms = useRecoilState(permissions)[0];

  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >=
    32;

  const navigate = useNavigate();

  async function Export() {
    try {
      setLoading(true);
      const response = await PaymentApi.exportPayment(
        filtros.statusFilter,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        ""
      );
      fileDownload(response, "pagamentos.xlsx");
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  async function getPaymentList() {
    try {
      setLoading(true);
      const response = await PaymentApi.getPaymentSolicitation(
        filtros.statusFilter,
        id,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        currentPage,
        pageSize,
        search,
        filtros.minValueFilter,
        filtros.maxValueFilter
      );
      setSalesList(response.data);
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setLoading(false);
      // console.log("response na lista", response.data);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getPaymentList();
    }
  }, [pages]);
  useEffect(() => {
    getPaymentList();
  }, [
    search,
    currentPage,
    pageSize,
    refresh,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.clientFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
    filtros.statusFilter,
  ]);

  interface StatusTypes {
    [chave: string]: JSX.Element;
  }

  const statusTypes: StatusTypes = {
    Efetivado: <FaCheck />,
    Processando: <FaExclamation />,
    Pendente: <FaExclamation />,
    "Remessa Gerada": <FaExclamation />,
    "Não efetivado": <FaExclamation />,
    Cancelado: <FaTimes />,
  };

  const arrayDeStatus = [
    { id: 1, status: "Pendente" },
    { id: 2, status: "Remessa Gerada" },
    { id: 3, status: "Processando" },
    { id: 4, status: "Efetivado" },
    { id: 5, status: "Cancelado" },
    { id: 6, status: "Não Efetivado" },
    { id: 7, status: "Pendente - Consumo" },
  ];

  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }

  const statusOptions =
    arrayDeStatus &&
    arrayDeStatus.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });

  // const setSelectedTransferId = useSetRecoilState(selectedTransfer);

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={colors.WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Boletos
          </Text>
        </Flex>
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        px={10}
        flexDirection={"column"}
      >
        <Text mb={2} fontWeight={"bold"}>
          Filtros
        </Text>
        <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
          {/* <Box w={"25%"}>
            <ClientFilterSelect filtros={filtros} setFiltros={setFiltros} />
          </Box> */}
          <DateDropdown filtros={filtros} setFiltros={setFiltros} />
          <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
          <Select
            fontSize={"0.8rem"}
            placeholder="Filtrar por Status"
            maxW={"14%"}
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
          >
            {statusOptions.map((item) => {
              return (
                <option value={item.value} key={item.key}>
                  {item.text}
                </option>
              );
            })}
          </Select>
          <Button
            bgColor={colors.GRAY_NEUTRAL}
            color={colors.WHITE}
            onClick={() => {
              setFiltros(initialValues);
            }}
          >
            Limpar Filtros
          </Button>
          <Button
            bg={"none"}
            color={colors.BLUEMONEDDBUTTONS}
            isDisabled={loading || dias}
            onClick={() => {
              Export();
            }}
            mx="10px"
            isLoading={loading}
            textTransform={"uppercase"}
            leftIcon={<FaFileExport />}
          >
            <Text fontSize={"0.8rem"}>Exporte</Text>
          </Button>
          {perms?.some((perm: any) => perm.idPermissoes === 40) && (
            <Button
              bgColor={colors.BLUEMONEDDBUTTONS}
              color={colors.WHITE}
              onClick={() => {
                goToAddPayment(navigate);
              }}
            >
              <Icon mr={2} as={FiPlus} />
              Inserir Pagamento Manual
            </Button>
          )}
        </Flex>
      </Flex>

      {loading ? (
        <Flex
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          justifyContent={"center"}
          alignItems={"center"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <Spinner size={"lg"} color={colors.VARIANT} />
        </Flex>
      ) : (
        <Box
          width={"100%"}
          height={"85%"}
          mt={"0.1%"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <TableContainer>
            <Table variant="striped" colorScheme="blue" size="sm">
              <Thead h="60px" position="sticky" top="0">
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data da Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Beneficiário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    CPF/CNPJ do Beneficiário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data de Pagamento
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data do Vencimento
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Juros
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Desconto
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Valor a Pagar
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Situação
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item: any, index: any) => {
                    return (
                      <Tr
                        key={index}
                        cursor="pointer"
                        onClick={() => {
                          // setIsOpen(true);
                          // setPaymentDetails(item.pagamentosHistorico);
                        }}
                      >
                        <Td borderRadius={"8px 0px 0px 8px"}>
                          {moment(item.criadoEm).format(dateForListWithHours)}
                        </Td>
                        <Td>{item.nomeBeneficiario}</Td>
                        <Td>
                          {item.cnpjBeneficiario.length === 14
                            ? CNPJFormater(item.cnpjBeneficiario)
                            : CPFFormater(item.cnpjBeneficiario)}
                        </Td>
                        <Td>
                          {moment(item.dataPagamento).format(dateForList)}
                        </Td>
                        <Td>{moment(item.vencimento).format(dateForList)}</Td>
                        <Td>
                          {item?.juros.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item?.descontos.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {(
                            item.valorNominal +
                            item.juros -
                            item.descontos
                          ).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>
                          {item.status.status === "Não efetivado" ? (
                            <Td>
                              <Tooltip
                                label={
                                  item.pagamentosHistorico[
                                    item?.pagamentosHistorico?.length - 1
                                  ].observacao
                                }
                                hasArrow
                                bg={colors.ORANGEMONEDD}
                                color="white"
                                placement="auto-start"
                              >
                                {statusTypes.hasOwnProperty(
                                  item.status.status
                                ) ? (
                                  <Flex
                                    alignItems={"center"}
                                    justifyContent="flex-start"
                                  >
                                    {statusTypes[item.status.status]}
                                    <Flex ml={4}>{item.status.status}</Flex>
                                  </Flex>
                                ) : (
                                  item.status.status
                                )}
                              </Tooltip>
                            </Td>
                          ) : (
                            <Td>
                              {statusTypes.hasOwnProperty(
                                item.status.status
                              ) ? (
                                <Flex
                                  alignItems={"center"}
                                  justifyContent="flex-start"
                                >
                                  {statusTypes[item.status.status]}
                                  <Flex ml={4}>{item.status.status}</Flex>
                                </Flex>
                              ) : (
                                item.status.status
                              )}
                            </Td>
                          )}
                        </Td>
                        <Td borderRadius={"0px 8px 8px 0px"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={colors.BLUEMONEDDBUTTONS}
                              color={colors.WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              {/* {item.status.status != "Cancelado" ? (
                              <MenuItem
                                icon={<FaTrash />}
                                onClick={() => {
                                  setIdBoleto(item.id);
                                  setOpenDelete(true);
                                }}
                              >
                                Cancelar Solicitação
                              </MenuItem>
                            ) : null} */}
                              <MenuItem
                                icon={<FaEye />}
                                onClick={() => {
                                  setIsOpen(true);
                                  setPaymentDetails(item.pagamentosHistorico);
                                }}
                              >
                                Visualizar Histórico
                              </MenuItem>
                              <MenuItem
                                icon={<FaPlus />}
                                onClick={() => {
                                  setOpenDetails(true);
                                  setDetails(item);
                                }}
                              >
                                Visualizar Detalhes
                              </MenuItem>
                              {item.status.status === "Efetivado" && (
                                <MenuItem
                                  icon={<FaLink />}
                                  as={"a"}
                                  target="_blank"
                                  href={
                                    item.urlRecibo
                                      ? `${baseURL}${
                                          item.urlRecibo.split("/api")[1]
                                        }&secret=${md5(
                                          `${item.idCliente}-${moment().format(
                                            "DD/MM/YYYY"
                                          )}`
                                        )}`
                                      : `${baseURL}/Imagem/recibo/boleto/${
                                          item.id
                                        }?secret=${md5(
                                          `${item.id}-${moment().format(
                                            "DD/MM/YYYY"
                                          )}`
                                        )}`
                                  }
                                >
                                  Visualizar Recibo
                                </MenuItem>
                              )}
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <ModalDeleteConfirmation
            isOpen={openDelete}
            setIsOpen={setOpenDelete}
            getTransferList={getPaymentList}
            id={idBoleto}
          />
          <ModalPaymentDetail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            item={paymentDetails}
          />
          <ModalDetails
            isOpen={openDetails}
            setIsOpen={setOpenDetails}
            item={details}
          />
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
            </Select>
          </Flex>
        </Box>
      )}
    </Flex>
  );
}
